import React from 'react';
import EmailInput from './EmailInput';
import PasswordInput from './PasswordInput';
import { useSharedContext } from '../../pages/GTBCustomize/ContextProviders/SharedContext';
import styles from './scss/CreateAccount.module.scss';
import { ValidateOnMount } from './props/inputProps';

type Props = {
  emailDisabled?: boolean;
  focusField?: string;
  validateOnMount?: ValidateOnMount;
};

const CreateAccount = (props: Props) => {
  const { emailDisabled, focusField, validateOnMount } = props;
  const {
    prospect, handleFormStateOnChange,
  } = useSharedContext();

  return (
    <section className={styles.createAccount}>
      <div className={styles.createAccountHeaderWrapper}>
        <h3 className={styles.createAccountHeader}>
          Create Account
        </h3>
      </div>
      <form>
        <EmailInput
          name="email"
          type="email"
          label="Email"
          autoComplete="email"
          maxLength={320}
          placeholder="Email"
          handleInput={handleFormStateOnChange}
          hasMargin
          value={prospect.email}
          errorMessage="Please enter a valid email."
          disabled={emailDisabled}
          focus={focusField === 'email'}
          validateOnMount={validateOnMount}
        />
        <PasswordInput
          name="password"
          type="password"
          label="Password"
          autoComplete="new-password"
          maxLength={256}
          placeholder="Create Password"
          handleInput={handleFormStateOnChange}
          value={prospect.password}
          errorMessage="Please enter a valid password."
          focus={focusField === 'password'}
        />
      </form>
    </section>
  );
};

CreateAccount.defaultProps = {
  emailDisabled: false,
  focusField: '',
  validateOnMount: 'none',
};

export default CreateAccount;
